var React = require('react');

function IconFacebook (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"17","cy":"17","r":"17","key":0}),React.createElement("path",{"d":"M20.4863 18.3125L20.8965 15.6172H18.2891V13.8594C18.2891 13.0977 18.6406 12.3945 19.8125 12.3945H21.0137V10.0801C21.0137 10.0801 19.9297 9.875 18.9043 9.875C16.7656 9.875 15.3594 11.1934 15.3594 13.5371V15.6172H12.957V18.3125H15.3594V24.875H18.2891V18.3125H20.4863Z","fill":"white","key":1})]);
}

IconFacebook.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none"};

module.exports = IconFacebook;

IconFacebook.default = IconFacebook;
